export default __webpack_public_path__ + "static/media/intro.2238ebe8.jpg";